import { render, staticRenderFns } from "./NotSupportAlert.vue?vue&type=template&id=fca12866&scoped=true&"
import script from "./NotSupportAlert.vue?vue&type=script&lang=js&"
export * from "./NotSupportAlert.vue?vue&type=script&lang=js&"
import style0 from "./NotSupportAlert.vue?vue&type=style&index=0&id=fca12866&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca12866",
  null
  
)

export default component.exports